module.exports = __webpack_public_path__ + "img/Wheel.cfafff5f.png";